<template>
  <div v-if="show" class="modalOverlay" @click.self="closeModal">

    <div class="modalCard">

      <header class="modalHeader">
        <h3>{{ title }}</h3>
        <button class="modalClose" @click="closeModal">×</button>
      </header>

      <div class="modalBody modalPercent">

        <button
          class="loginbtn primaryBtn"
          @click="downloadReport"
        >
          Descargar Reporte
        </button>

      </div>

    </div>

  </div>
</template>

<script>
import * as XLSX from 'xlsx'

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: 'Título del Modal',
    },
    infoFinalReportPreComision: {
      type: Array,
      required: false,
    },
    infoFinalReportPDComision: {
      type: Array,
      required: false,
    },
  },

  methods: {

    closeModal() {
      this.$emit('close')
    },

    downloadReport() {

      const ws1 = XLSX.utils.json_to_sheet(this.infoFinalReportPreComision)
      const ws2 = XLSX.utils.json_to_sheet(this.infoFinalReportPDComision)

      const wb = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(wb, ws1, 'Pre Comisión')
      XLSX.utils.book_append_sheet(wb, ws2, 'Pedientes Descontar')

      XLSX.writeFile(wb, 'reporte_comision.xlsx')
    }

  }
}
</script>